import * as _ from "lodash";
import * as React from "react";
import { default as TriggerInput, InputMode } from "./TriggerInput";
import { IQueueTriggerBaseConfig } from "processEditor/model/ITriggerData";
export const QueueTrigger: React.FunctionComponent<QueueTriggerProps> = (props) => {

    function isReplyDisabled(): boolean {
        const value = !_.get(props.existingParameters, "reply", false) && !_.get(props.existingParameters, "replyErrors", false);
        return value;
    }

    return (<div>
        <TriggerInput existingParameters={props.existingParameters} name="queueName" label={FRENDS.Localizations.Triggers_Queue} inputMode={InputMode.text} elementId={props.id} />
        <TriggerInput existingParameters={props.existingParameters} name="busUri" label={FRENDS.Localizations.Triggers_BusUri} inputMode={InputMode.text} elementId={props.id} />
        <TriggerInput existingParameters={props.existingParameters} name="reply" label={FRENDS.Localizations.Triggers_Reply} inputMode={InputMode.boolean} elementId={props.id} />
        <TriggerInput existingParameters={props.existingParameters} name="replyErrors" label={FRENDS.Localizations.Triggers_ReplyErrors} inputMode={InputMode.boolean} elementId={props.id} />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="replyTo"
            label={FRENDS.Localizations.Triggers_ReplyTo}
            inputMode={InputMode.text}
            disabled={isReplyDisabled()}
            elementId={props.id}
        />
        <TriggerInput
            existingParameters={props.existingParameters}
            name="durable"
            label={FRENDS.Localizations.Triggers_Durable}
            description={FRENDS.Localizations.Triggers_DurableDescription}
            inputMode={InputMode.boolean}
            elementId={props.id}
        />
    </div>);
};

export interface QueueTriggerConfig extends IQueueTriggerBaseConfig {
    busUri: string;
    durable: boolean;
}
interface QueueTriggerProps {
    id: string;
    existingParameters: QueueTriggerConfig;
}
